const services = [
  {
    icon: 'ri-fire-line',
    title: 'Dépannage Chauffage',
    description: 'Intervention rapide pour tous types de pannes de chauffage : pompes à chaleur, chaudières, radiateurs. Diagnostic précis et réparation efficace.',
    features: ['Diagnostic en 1h', 'Pièces de rechange', 'Garantie intervention']
  },
  {
    icon: 'ri-flashlight-line',
    title: 'Urgence Électrique',
    description: 'Dépannage électrique d\'urgence pour pannes de courant, courts-circuits, disjoncteurs. Sécurisation immédiate de vos installations.',
    features: ['Intervention 24/7', 'Mise en sécurité', 'Conformité suisse']
  },
  {
    icon: 'ri-drop-line',
    title: 'Plomberie Urgente',
    description: 'Réparation de fuites, débouchage, problèmes de chauffe-eau. Intervention rapide pour limiter les dégâts et restaurer votre confort.',
    features: ['Détection fuites', 'Débouchage rapide', 'Réparation durable']
  },
  {
    icon: 'ri-windy-line',
    title: 'Ventilation et Climatisation',
    description: 'Maintenance et dépannage de systèmes de ventilation et climatisation. Garantie d\'un air sain et d\'une température optimale.',
    features: ['Nettoyage filtres', 'Recharge gaz', 'Optimisation système']
  },
  {
    icon: 'ri-tools-line',
    title: 'Maintenance Préventive',
    description: 'Contrats de maintenance personnalisés pour éviter les pannes. Inspections régulières et entretien de vos équipements CVSE.',
    features: ['Visites planifiées', 'Rapport détaillé', 'Priorité intervention']
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Contrôle de Conformité',
    description: 'Vérification et mise en conformité de vos installations selon les normes suisses. Certification et documentation complète.',
    features: ['Audit complet', 'Mise aux normes', 'Certification officielle']
  }
];

export default function MaintenanceServices() {
  return (
    <section className="py-24 bg-gray-950">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-base font-semibold leading-7 text-orange-400">Nos Services</h2>
          <p className="mt-2 text-4xl font-bold tracking-tight text-white sm:text-5xl">
            Maintenance et Dépannage Complets
          </p>
          <p className="mt-6 text-lg leading-8 text-gray-400 max-w-3xl mx-auto">
            Une équipe de techniciens qualifiés disponible 24h/24 et 7j/7 pour tous vos besoins en maintenance et dépannage CVSE. Interventions rapides et professionnelles dans toute la Suisse romande.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-gray-900 rounded-2xl p-8 border border-gray-800 hover:border-orange-500/40 transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-orange-500/20 rounded-xl mb-6">
                <i className={`${service.icon} text-3xl text-orange-400`}></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-3">{service.title}</h3>
              <p className="text-gray-400 mb-6 leading-relaxed">{service.description}</p>
              <ul className="space-y-2">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center text-sm text-gray-300">
                    <i className="ri-check-line text-orange-400 mr-2"></i>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
